
const HomePageOne = () => import('@/modules/marketplace/pages/HomePageOne.vue')

const VendorHomePage = () => import('@/modules/vendor/pages/VendorHomePage.vue')

const CompaniesAvailablePage = () => import('@/shared/pages/CompaniesAvailablePage.vue')
import DownloadAppPage from '@/modules/marketplace/pages/DownloadAppPage.vue'
import VendorSchedulePage from '@/modules/vendor/pages/VendorSchedulePage.vue'
import { getAppModeFromEnv, isVendorMode } from '@/shared/utils/appMode'
import type { RouteRecordRaw } from 'vue-router'
const DefaultLayout = () => import('@/app/layouts/SharedLayout.vue')

const HomePage = () => import('@/modules/marketplace/pages/HomePage.vue')
const HomeCustomerHoaPage = () => import('@/modules/marketplace/pages/HomeCustomerHoaPage.vue')
const HomeCustomerPage = () => import('@/modules/marketplace/pages/HomeCustomerPage.vue')

const PestControlPage = () => import('@/modules/marketplace/pages/PestControlPage.vue')
const CleaningPage = () => import('@/modules/marketplace/pages/CleaningPage.vue')
const PlumbingPage = () => import('@/modules/marketplace/pages/PlumbingPage.vue')
const RoofingPage = () => import('@/modules/marketplace/pages/RoofingPage.vue')
const LandscapingPage = () => import('@/modules/marketplace/pages/LandscapingPage.vue')
const MoversPage = () => import('@/modules/marketplace/pages/MoversPage.vue')
const ElectricalPage = () => import('@/modules/marketplace/pages/ElectricalPage.vue')
const PaintersPage = () => import('@/modules/marketplace/pages/PaintersPage.vue')
const ContractorsPage = () => import('@/modules/marketplace/pages/ContractorsPage.vue')
const PoolSpaPage = () => import('@/modules/marketplace/pages/PoolSpaPage.vue')
const TreeServicesPage = () => import('@/modules/marketplace/pages/TreeServicesPage.vue')
const JunkRemovalPage = () => import('@/modules/marketplace/pages/JunkRemovalPage.vue')
const ConcreteMasonryPage = () => import('@/modules/marketplace/pages/ConcreteMasonryPage.vue')
const WindowsDoorsPage = () => import('@/modules/marketplace/pages/WindowsDoorsPage.vue')
const FurnaceRepairPage = () => import('@/modules/marketplace/pages/FurnaceRepairPage.vue')
const GarageDoorRepairPage = () => import('@/modules/marketplace/pages/GarageDoorRepairPage.vue')
const LocksmithsPage = () => import('@/modules/marketplace/pages/LocksmithsPage.vue')
const HandymenPage = () => import('@/modules/marketplace/pages/HandymenPage.vue')
const HVACPage = () => import('@/modules/marketplace/pages/HVACPage.vue')
const DogTrainerPage = () => import('@/modules/marketplace/pages/DogTrainerPage.vue')
const PersonalTrainerPage = () => import('@/modules/marketplace/pages/PersonalTrainerPage.vue')
const DJPage = () => import('@/modules/marketplace/pages/DJPage.vue')
const MakeupArtistPage = () => import('@/modules/marketplace/pages/MakeupArtistPage.vue')
const PhotographersPage = () => import('@/modules/marketplace/pages/PhotographersPage.vue')
const WeddingPlannerPage = () => import('@/modules/marketplace/pages/WeddingPlannerPage.vue')
const BookKeepingPage = () => import('@/modules/marketplace/pages/BookKeepingPage.vue')
const MagicianPage = () => import('@/modules/marketplace/pages/MagicianPage.vue')
const CounselingPage = () => import('@/modules/marketplace/pages/CounselingPage.vue')
const MassageTherapistPage = () => import('@/modules/marketplace/pages/MassageTherapistPage.vue')
const TaxServicesPage = () => import('@/modules/marketplace/pages/TaxServicesPage.vue')

// Special pages
const FreeEstimatePage = () => import('@/modules/marketplace/pages/FreeEstimatePage.vue')
const FreeEstimateServicePage = () => import('@/modules/marketplace/pages/FreeEstimateServicePage.vue')
const FreeEstimationFormPage = () => import('@/modules/marketplace/pages/FreeEstimationFormPage.vue')
const SchedulePage = () => import('@/modules/marketplace/pages/SchedulePage.vue')
const ScheduleFormPage = () => import('@/modules/marketplace/pages/ScheduleFormPage.vue')
const RecurringPage = () => import('@/modules/marketplace/pages/RecurringPage.vue')
const RecurringFormPage = () => import('@/modules/marketplace/pages/RecurringFormPage.vue')
const InspectionPage = () => import('@/modules/marketplace/pages/InspectionPage.vue')
const InspectionFormPage = () => import('@/modules/marketplace/pages/InspectionFormPage.vue')
const InquirySuccessPage = () => import('@/modules/marketplace/pages/InquirySuccessPage.vue')
const ServiceRequestSuccessPage = () => import('@/modules/marketplace/pages/ServiceRequestSuccessPage.vue')
const PestControlVendorProfilePage = () => import('@/modules/marketplace/pages/PestControlVendorProfilePage.vue')
const PestControlServiceDetailPage = () => import('@/modules/marketplace/pages/pest-control/ServiceDetailPage.vue')

// Common pages currently in customer module but are marketplace-oriented
const AboutPage = () => import('@/modules/customer/pages/AboutPage.vue')
const ContactPage = () => import('@/modules/customer/pages/ContactPage.vue')

const vendor_components = {
  'home': VendorHomePage
}

const customer_hoa_components = {
  'home': HomeCustomerHoaPage
}

const customer_components = {
  'home': HomeCustomerPage
}

function getComponent(componentName: string) {
  switch (getAppModeFromEnv()) {
    case 'vendor':
      return vendor_components[componentName] = vendor_components[componentName] || HomePage;
    case 'customer_hoa':
      return customer_hoa_components[componentName] = customer_hoa_components[componentName] || HomePage;

    case 'customer':
      return customer_components[componentName] = customer_components[componentName] || HomePage;
    default:
      return HomePage;
  }
}

const sharedPublicRoutes: RouteRecordRaw[] = [
  // {
  //   path: '',
  //   name: 'marketplace.home',
  //   component: getComponent('home'),
  //   meta: { title: 'Home', requiresAuth: false }
  // },
  {
    path: 'download-app',
    name: 'customer.download-app',
    component: DownloadAppPage,
    meta: { title: 'Back' }
  },
  {
    path: 'schedule-demo',
    name: 'schedule-demo.form',
    component: VendorSchedulePage,
    meta: { title: 'Back' }
  },
  {
    path: '/about',
    name: 'marketplace.about',
    component: AboutPage,
    meta: { title: 'About Us', requiresAuth: false }
  },
  {
    path: '/contact',
    name: 'marketplace.contact',
    component: ContactPage,
    meta: { title: 'Contact Us', requiresAuth: false }
  },
  {
    path: '/pest-control',
    name: 'marketplace.pest-control',
    component: PestControlPage,
    meta: { title: 'Pest Control Services', requiresAuth: false }
  },
  {
    path: '/cleaning',
    name: 'marketplace.cleaning',
    component: CleaningPage,
    meta: { title: 'Cleaning Services', requiresAuth: false }
  },
  {
    path: '/plumbing',
    name: 'marketplace.plumbing',
    component: PlumbingPage,
    meta: { title: 'Plumbing Services', requiresAuth: false }
  },
  {
    path: '/roofing',
    name: 'marketplace.roofing',
    component: RoofingPage,
    meta: { title: 'Roofing Services', requiresAuth: false }
  },
  {
    path: '/landscaping',
    name: 'marketplace.landscaping',
    component: LandscapingPage,
    meta: { title: 'Landscaping Services', requiresAuth: false }
  },
  {
    path: '/movers',
    name: 'marketplace.movers',
    component: MoversPage,
    meta: { title: 'Moving Services', requiresAuth: false }
  },
  {
    path: '/electrical',
    name: 'marketplace.electrical',
    component: ElectricalPage,
    meta: { title: 'Electrical Services', requiresAuth: false }
  },
  {
    path: '/painters',
    name: 'marketplace.painters',
    component: PaintersPage,
    meta: { title: 'Painting Services', requiresAuth: false }
  },
  {
    path: '/contractors',
    name: 'marketplace.contractors',
    component: ContractorsPage,
    meta: { title: 'General Contractors', requiresAuth: false }
  },
  {
    path: '/pool-spa',
    name: 'marketplace.pool-spa',
    component: PoolSpaPage,
    meta: { title: 'Pool & Spa Services', requiresAuth: false }
  },
  {
    path: '/tree-services',
    name: 'marketplace.tree-services',
    component: TreeServicesPage,
    meta: { title: 'Tree Services', requiresAuth: false }
  },
  {
    path: '/junk-removal',
    name: 'marketplace.junk-removal',
    component: JunkRemovalPage,
    meta: { title: 'Junk Removal', requiresAuth: false }
  },
  {
    path: '/concrete-masonry',
    name: 'marketplace.concrete-masonry',
    component: ConcreteMasonryPage,
    meta: { title: 'Concrete & Masonry', requiresAuth: false }
  },
  {
    path: '/windows-doors',
    name: 'marketplace.windows-doors',
    component: WindowsDoorsPage,
    meta: { title: 'Windows & Doors', requiresAuth: false }
  },
  {
    path: '/furnace-repair',
    name: 'marketplace.furnace-repair',
    component: FurnaceRepairPage,
    meta: { title: 'Furnace Repair', requiresAuth: false }
  },
  {
    path: '/garage-door-repair',
    name: 'marketplace.garage-door-repair',
    component: GarageDoorRepairPage,
    meta: { title: 'Garage Door Repair', requiresAuth: false }
  },
  {
    path: '/locksmiths',
    name: 'marketplace.locksmiths',
    component: LocksmithsPage,
    meta: { title: 'Locksmith Services', requiresAuth: false }
  },
  {
    path: '/handymen',
    name: 'marketplace.handymen',
    component: HandymenPage,
    meta: { title: 'Handyman Services', requiresAuth: false }
  },
  {
    path: '/hvac',
    name: 'marketplace.hvac',
    component: HVACPage,
    meta: { title: 'HVAC Services', requiresAuth: false }
  },
  {
    path: '/dog-trainer',
    name: 'marketplace.dog-trainer',
    component: DogTrainerPage,
    meta: { title: 'Dog Training', requiresAuth: false }
  },
  {
    path: '/personal-trainer',
    name: 'marketplace.personal-trainer',
    component: PersonalTrainerPage,
    meta: { title: 'Personal Training', requiresAuth: false }
  },
  {
    path: '/dj',
    name: 'marketplace.dj',
    component: DJPage,
    meta: { title: 'DJ Services', requiresAuth: false }
  },
  {
    path: '/makeup-artist',
    name: 'marketplace.makeup-artist',
    component: MakeupArtistPage,
    meta: { title: 'Makeup Artist', requiresAuth: false }
  },
  {
    path: '/photographers',
    name: 'marketplace.photographers',
    component: PhotographersPage,
    meta: { title: 'Photography Services', requiresAuth: false }
  },
  {
    path: '/wedding-planner',
    name: 'marketplace.wedding-planner',
    component: WeddingPlannerPage,
    meta: { title: 'Wedding Planning', requiresAuth: false }
  },
  {
    path: '/bookkeeping',
    name: 'marketplace.bookkeeping',
    component: BookKeepingPage,
    meta: { title: 'Bookkeeping Services', requiresAuth: false }
  },
  {
    path: '/magician',
    name: 'marketplace.magician',
    component: MagicianPage,
    meta: { title: 'Magician Services', requiresAuth: false }
  },
  {
    path: '/counseling',
    name: 'marketplace.counseling',
    component: CounselingPage,
    meta: { title: 'Counseling Services', requiresAuth: false }
  },
  {
    path: '/massage-therapist',
    name: 'marketplace.massage-therapist',
    component: MassageTherapistPage,
    meta: { title: 'Massage Therapy', requiresAuth: false }
  },
  {
    path: '/tax-services',
    name: 'marketplace.tax-services',
    component: TaxServicesPage,
    meta: { title: 'Tax Services', requiresAuth: false }
  },
  // Special routes
  {
    path: '/free-estimate',
    name: 'marketplace.free-estimate',
    component: FreeEstimatePage,
    meta: { title: 'Free Estimate', requiresAuth: false }
  },
  {
    path: '/free-estimate/:service_slug',
    name: 'marketplace.free-estimate.service',
    component: FreeEstimateServicePage,
    meta: { title: 'Free Estimate', requiresAuth: false }
  },
  {
    path: '/free-estimation-form/:vendor_code',
    name: 'marketplace.free-estimation.form',
    component: FreeEstimationFormPage,
    meta: { title: 'Free Estimation Form', requiresAuth: false }
  },
  {
    path: '/free-estimation-form/:vendor_code/success',
    name: 'marketplace.inquiry-success',
    component: InquirySuccessPage,
    meta: { title: 'Inquiry Submitted', requiresAuth: false }
  },
  {
    path: '/schedule',
    name: 'marketplace.schedule',
    component: SchedulePage,
    meta: { title: 'Schedule Service', requiresAuth: false }
  },
  {
    path: '/schedule/:vendor_code',
    name: 'marketplace.schedule-form',
    component: ScheduleFormPage,
    meta: { title: 'Back', requiresAuth: false }
  },
  {
    path: '/schedule/:vendor_code/success',
    name: 'marketplace.schedule-success',
    component: ServiceRequestSuccessPage,
    meta: { title: 'Schedule Submitted', requiresAuth: false }
  },
  {
    path: '/recurring',
    name: 'marketplace.recurring',
    component: RecurringPage,
    meta: { title: 'Recurring Service', requiresAuth: false }
  },
  {
    path: '/recurring/:vendor_code',
    name: 'marketplace.recurring-form',
    component: RecurringFormPage,
    meta: { title: 'Back', requiresAuth: false }
  },
  {
    path: '/recurring/:vendor_code/success',
    name: 'marketplace.recurring-success',
    component: ServiceRequestSuccessPage,
    meta: { title: 'Recurring Submitted', requiresAuth: false }
  },
  {
    path: '/inspection',
    name: 'marketplace.inspection',
    component: InspectionPage,
    meta: { title: 'Inspection Service', requiresAuth: false }
  },
  {
    path: '/inspection/:vendor_code',
    name: 'marketplace.inspection-form',
    component: InspectionFormPage,
    meta: { title: 'Back', requiresAuth: false }
  },
  {
    path: '/pest-control/vendor/:vendor_code',
    name: 'marketplace.pest-control.vendor',
    component: PestControlVendorProfilePage,
    meta: { title: 'Vendor Profile', requiresAuth: false }
  },
  {
    path: '/pest-control/service/:vendor_code/:service_slug',
    name: 'marketplace.pest-control.service.detail.legacy',
    component: PestControlServiceDetailPage,
    meta: { title: 'Service Detail', requiresAuth: false }
  },
  {
    path: '/pest-control/service/:service_id',
    name: 'marketplace.pest-control.service.detail',
    component: PestControlServiceDetailPage,
    meta: { title: 'Service Detail', requiresAuth: false }
  },

]

export const sharedRoutes: RouteRecordRaw[] = [
  // top-level home route (outside DefaultLayout)
  {
    path: '/companies-available',
    name: 'companies.available',
    component: CompaniesAvailablePage,
    meta: { title: 'Choose Company', requiresAuth: false }
  },
  {
    path: '',
    name: 'marketplace.home',
    component: getComponent('home'),
    beforeEnter() {
      if(getAppModeFromEnv() === "customer_hoa") {
        if(String(localStorage.getItem("app-code") || "").trim()) {
          return true;
        }
        return { name: "companies.available" };
      }

      return true;
    },
    meta: { title: 'Home', requiresAuth: false }
  },
  {
    path: '/',
    component: DefaultLayout,
    meta: { requiresAuth: false },
    children: sharedPublicRoutes
      .filter((r) => r.name !== 'marketplace.home' && r.path !== '')
      .map((route) => ({
        ...route,
        path: route.path.replace(/^\//, '') // ensure child paths are relative
      })),
  },
]
